<template>
<div class="blog-wrapper">
  <div class="header"></div>
  <div class="blog">
    <div class="blog-header">
      Nuestro blog
    </div>
    <div class="blog-posts">
      <div class="blog-section">
        Lo último
      </div>
      <div
        class="blog-post"
        v-for="post in posts"
        :key="post.id"
        @click="$router.push(`/blog/${post.id}`)">
        <div
          class="post-image"
          :style="{ backgroundImage: `url(${post.imageUrl})` }" />
        <div class="post-date">
          {{ moment(post.created_at).fromNow() }}
        </div>
        <div class="post-name">
          {{ post.title }}
        </div>
        <div class="post-summary">
          {{ post.summary }}
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';

const { mapState, mapActions } = createNamespacedHelpers('blog');
export default {
  data() {
    return {
      moment,
    };
  },
  computed: {
    ...mapState([
      'posts',
    ]),
  },
  methods: {
    ...mapActions([
      'getPosts',
    ]),
  },
  mounted() {
    this.getPosts();
    moment.locale('es');
  },
};
</script>
<style lang="scss" scoped>
.blog-wrapper {
  height: 100vh;
  background-color: #f6f6f6;
}
.header {
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("/background.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.blog {
  display: flex;
  flex-direction: column;
  min-width: 100%;
  margin-top: -100px;
  align-items: center;
}
.blog-header {
  //background-color: #2c70c1;
  background-color: white;
  font-weight: bolder;
  font-size: 38px;
  width: 1100px;
  height: 120px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  //color: white;
}
.blog-posts {
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  width: 1100px;
  justify-content: space-evenly;
  padding: 0 20px;
  padding-bottom: 40px;
}
.blog-section {
  width: 100%;
  padding: 0 20px;
  font-weight: bolder;
  font-size: 24px;
}
.blog-post {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  margin-top: 24px;
  width: 31%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  cursor: pointer;

  &:hover {
    border: 1px solid #2c70c1;
  }
}
.post-image {
  width: 100%;
  height: 150px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 2px;
  margin-bottom: 16px;
}
.post-date {
  background-color: white;
  font-size: 16px;
  margin-bottom: 20px;
  color: #2c70c1;
}
.post-name {
  font-size: 28px;
  font-weight: bold;
  color: black;
  width: 100%;
  height: 125px;
}
.post-summary {
  background-color: white;
  font-size: 16px;
  line-height: 1.5;
}
@media only screen and (max-width: 1200px) {
  .blog-header {
    width: 100%;
  }
  .blog-posts {
    width: 100%;
  }
}
@media only screen and (max-width: 900px) {
  .blog-posts {
    padding: 0 20px;
    padding-bottom: 40px;
  }
  .blog-post {
    width: 900%;
  }
}
</style>

